import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { TextFieldInput } from "sprout-ui-dom/dist/TextField_next";
import { Box } from "sprout-ui-primitives";
import { PopoverDialogSaveButton } from "sprout-ui-dom/dist/PopoverDialog";
import { Form } from "sprout-ui-dom/dist/Form";
import PopoverDialogContent from "../PopoverDialogContent";
const TextFieldPopoverDialogInner = (props)=>{
    const { text , placeholder , onRequestClose , onChange , onSubmit , inputRef  } = props;
    const handleKeyDown = useCallback((event)=>{
        if (event.key === "Escape") onRequestClose();
    }, [
        onRequestClose
    ]);
    return /*#__PURE__*/ _jsxs(PopoverDialogContent, {
        as: Form,
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ _jsx(Box, {
                mb: 3,
                children: /*#__PURE__*/ _jsx(TextFieldInput, {
                    value: text,
                    autoFocus: true,
                    onChange: onChange,
                    placeholder: placeholder,
                    maxLength: 50,
                    autoComplete: "off",
                    onKeyDown: handleKeyDown,
                    ref: inputRef
                })
            }),
            /*#__PURE__*/ _jsx(PopoverDialogSaveButton, {
                variant: "bright-teal",
                type: "submit",
                children: "Save"
            })
        ]
    });
};
export default TextFieldPopoverDialogInner;
